import { type CompanyInfo } from '@customTypes/userInfo';

export default (companyInfo: CompanyInfo) => {
  const isCompany =
    companyInfo?.type === 'bv' || companyInfo?.type === 'commV' || companyInfo?.type === 'vof';
  return isCompany;
};
